// extracted by mini-css-extract-plugin
export default {"reclaim-button":"reclaim-button_vht6r","action-item":"action-item_umgDM"};